import React from 'react';

import { ButtonDark } from './styles';
import colors from '../../../styles/colors';
import { PulseLoader } from 'react-spinners';
interface IButton {
  name: string;
  loading: boolean;
}

export const Button = ({ name, loading }: IButton): JSX.Element => {
  return (
    <ButtonDark type="submit" disabled={loading}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          width: '100%',
          padding: '5px',
        }}
      >
        {loading && (
          <span>
            <PulseLoader color={colors.gold} size={12} />
          </span>
        )}
        {!loading && (
          <span
            style={{ fontSize: '16px', textAlign: 'center', width: '100%' }}
          >
            {name}
          </span>
        )}
      </div>
    </ButtonDark>
  );
};
